type Props = {
    title: string;
    value: number;
};

const HighlightCard = ({ title, value }: Props) => {
    return (
        <div className="bg-gradient-to-r from-red-500 to-red-600 text-white p-6 rounded-2xl shadow-lg">
            <p className="text-sm opacity-90">{title}</p>
            <h1 className="text-3xl font-bold mt-2">
                QAR {value.toLocaleString()}
            </h1>
        </div>
    );
};

export default HighlightCard;